






























import { Component, Vue, Prop } from "vue-property-decorator"
import { mapState } from "vuex"

@Component({
  computed: {
    ...mapState("MediaFile", {
      mediaFiles: "mediaFiles",
    }),
  },
})
export default class QMediaLibrary extends Vue {
  @Prop() readonly modelName!: string
  @Prop() readonly modelOid!: string

  mediaFiles!: Model[]

  newMediaFile = {}
  selection: Model = {}

  beforeMount() {
    this.$store.dispatch("MediaFile/fetchList")
  }

  handleNewMediaFile() {
    this.mediaFiles.push(this.newMediaFile)
  }

  setSelection(mediaFile) {
    if (this.selection.object_id != mediaFile.object_id) {
      this.selection = mediaFile
    } else {
      this.selection = {}
    }
  }
}
